import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {FrameExternalRoutes, CanMatchGuard, FrameLazyLoadingInternalRoutes} from '@overflo1/frame-frontend';
import {MachineRoutes} from './machine/machine.routes';
import {MenuComponent} from './shared/components/menu/menu.component';
import {FamilyRoutes} from "./family/family.routes";

const guards: any[] = [CanMatchGuard];

const routes: Routes = [
  ...FrameExternalRoutes,
  {
    path: '',
    component: MenuComponent,
    children: [
      {
        path: 'home',
        loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
        canMatch: guards
      },
      ...MachineRoutes,
      ...FamilyRoutes,
      ...FrameLazyLoadingInternalRoutes,
      {path: '**', redirectTo: 'home', pathMatch: 'full'},
    ]
  },
  {path: '**', redirectTo: 'login', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [CanMatchGuard]
})
export class AppRoutingModule {
}
